import { FC } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Modal from "components/Modal";
import CustomButton from "components/CustomButton";

import { APP_ROUTES } from "config/routes";

interface AfterDecentralandRedeemModalProps {
  isOpen?: boolean;
  itemName: string;
}

const AfterDecentralandRedeemModal: FC<AfterDecentralandRedeemModalProps> = ({
  isOpen,
  itemName,
}) => {
  return (
    <Modal isOpen={isOpen} title="Success!" disableBackdropClick>
      <Box maxWidth={350} sx={{ minWidth: { md: 350 }, display: "grid" }}>
        <Typography align="center" mb={2}>
          You've successfully redeemed your item <strong>{itemName}</strong> as
          a Decentraland Wearable.
          <br />
          It will be transferred to your wallet within 72h.
        </Typography>

        <CustomButton href={APP_ROUTES.MY_ITEMS} sx={{ mx: "auto" }}>
          Go to My Items
        </CustomButton>
      </Box>
    </Modal>
  );
};

export default AfterDecentralandRedeemModal;
